import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './sic-featured-content-hero.css.lit';
import defaultVars from './css-variables/sic-featured-content-hero-vars.css.lit';

/**
 * The SicFeaturedContentHero component
 * @element sic-featured-content-hero
 *
 * @slot - default
 * @slot eyebrow - eyebrow slot (page title)
 * @slot heading - heading slot
 * @slot hero-card - card slot
 *
 */

@customElement('sic-featured-content-hero')
export class FeaturedContentHero extends OutlineElement {
  static styles: CSSResultGroup = [defaultVars, componentStyles];

  updated() {
    this.setBreadcrumbVars();
  }

  /**
   * Set css vars for breadcrumb injecting an inline <style>.
   */
  setBreadcrumbVars() {
    const breadcrumb = document.querySelector<HTMLElement>('sic-breadcrumb');
    if (breadcrumb) {
      breadcrumb.style.setProperty(
        '--sic-breadcrumb--override--background-color',
        'var(--color-primary-default)'
      );
      breadcrumb.style.setProperty(
        '--sic-breadcrumb--override--text-color',
        'var(--color-neutral-white)'
      );
      breadcrumb.style.setProperty(
        '--sic-breadcrumb--override--icon-color',
        'var(--color-neutral-white)'
      );
    }
  }
  render(): TemplateResult {
    return html`
      <div class="landing-hero-wrapper">
        <sic-container
          container-width="full"
          background-color="primary-default"
          top-padding="none"
          bottom-padding="normal"
          x-padding="none"
        >
          <sic-container
            class="hero-wrapper"
            top-padding="none"
            bottom-padding="none"
            container-width="normal"
          >
            <div class="content-wrapper">
              <div class="text-wrapper">
                <slot name="hero-eyebrow" class="hero-eyebrow"></slot>
                <slot name="hero-heading" class="hero-heading"></slot>
              </div>
              <slot class="hero-card" name="hero-card"></slot>
            </div>
          </sic-container>
        </sic-container>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-featured-content-hero': FeaturedContentHero;
  }
}
